
import React, { useEffect,useState } from 'react';
import { useHistory } from 'react-router-dom';
import {raraweblogo } from '../../../constants/iconImageConstant';
import { Header } from '../../Header/Header';
import { Footer } from '../../appFooter/Footer';

    export function MobAeraPage() {

      const history = useHistory();
      const handleNavigate = (path: string) => {
        history.push(path);
      };

    
      const handleKnowMore = () => { window.open( 'https://annawards.com/event/national/', '_blank', 'noopener,noreferrer' ); };
  

      return (
    <>
   <Header />
    <div className="main-container">
      <main role="main" className="mobile-bg">

        {/* RAEA Logo */}
         <div
         className="col-md-12 col-sm-12"
        style={{ marginTop: '30px' }}>
                <div className="dahihandi-logo-container">
                      <img
                        src={raraweblogo}
                        alt="RAEA Logo"
                      />
                    </div>
                  </div>
                
        
        {/* RAEA Content */}
          <div className="col-md-12">
           <div className="abt_raea">


                  <p>
                    The Ramoji Animation Excellence Awards (RAEA) are
                    inspired by the visionary legacy of Sri Ramoji Rao,
                    a pioneer who transformed storytelling into a
                    powerful cultural force.
                  </p>

                  <p>
                    Honoring excellence across key categories namely{' '}
                    <span>Best Young Animator 2026</span> and{' '}
                    <span>Best Indie Studio 2026.</span> RAEA recognizes
                    originality, collaboration and craftsmanship,
                    inspiring the next generation to push creative
                    boundaries and elevating Indian animation on the
                    global stage.
                  </p>

                  <p>
                    Established to celebrate emerging talent and drive
                    innovation in India’s animation ecosystem, the debut
                    edition of the awards is being held on August 28,
                    2026, in Mumbai.
                  </p>

                </div>
                
                {/* Know More Button */}
                
                   
               

              {/* Right Video */}
             <div className="col-md-12">
                <video
                  autoPlay
                  loop
                  playsInline
                  controls
                  width="100%"
                  className="video-frame"
                  >
                 <source src="https://assets.etvbalbharat.com/video/RAMOJI_EXCELLENCE_AWARDS_TRAILER.mp4" type="video/mp4" />

                  Your browser does not support the video tag.
                </video>
              </div>


               <div className="col-md-12 text-center">
                  <a
                    href="https://annawards.com/event/national/"
                    className="ckm"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    CLICK TO KNOW MORE
                  </a>
                </div>
             </div>
      </main>
    </div>
  <Footer/>
    </>
  );
}

